
<a href="" class="btn" @click="toggle">
  <i v-if="checked" class="fa fa-lg fa-check-square checked"></i>
  <i v-else class="fa fa-lg fa-check-square "></i>
  {{ title }}
</a>
